/**
 * Trending collection: tabbed product grid using Section Rendering API.
 * Each tab maps to a Shopify collection. On tab switch, the section is
 * re-rendered in the context of that collection's URL, so the global
 * `collection` Liquid object resolves to the correct collection.
 */
(function () {
  function initTrending(root) {
    var tabs = root.querySelectorAll('[data-trending-tab]');
    var grid = root.querySelector('[data-trending-grid]');
    var sectionId = root.getAttribute('data-section-id');
    if (!tabs.length || !grid || !sectionId) return;

    var active = 0;
    var cache = {};
    var loading = false;

    // Find initially active tab
    tabs.forEach(function (el) {
      if (el.style.borderColor === '#000' || el.style.borderColor === 'rgb(0, 0, 0)') {
        active = parseInt(el.getAttribute('data-trending-tab'), 10);
      }
    });

    function setTabState(idx) {
      tabs.forEach(function (el) {
        var i = parseInt(el.getAttribute('data-trending-tab'), 10);
        var on = i === idx;
        el.style.borderColor = on ? '#000' : '#ccc';
      });
    }

    function switchTab(idx) {
      if (idx === active || loading) return;
      active = idx;
      setTabState(idx);

      if (cache[idx]) {
        grid.innerHTML = cache[idx];
        reobserveAnimations(grid);
        return;
      }

      var tab = tabs[idx];
      var collectionUrl = tab.getAttribute('data-collection-url');
      if (!collectionUrl) return;

      loading = true;
      grid.style.opacity = '0.5';
      grid.style.transition = 'opacity 150ms';

      fetchSection(collectionUrl, [sectionId])
        .then(function (sections) {
          var html = sections[sectionId];
          if (!html) return;

          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-trending-grid]');

          if (newGrid) {
            cache[idx] = newGrid.innerHTML;
            grid.innerHTML = newGrid.innerHTML;
            reobserveAnimations(grid);
          }
        })
        .catch(function (err) {
          console.error('Trending tab fetch failed:', err);
        })
        .finally(function () {
          loading = false;
          grid.style.opacity = '1';
        });
    }

    function reobserveAnimations(container) {
      if (!window.themeAnimationObserver) return;
      container.querySelectorAll('[data-animate]').forEach(function (el) {
        el.classList.remove('is-visible');
        window.themeAnimationObserver.observe(el);
      });
    }

    tabs.forEach(function (el) {
      el.addEventListener('click', function () {
        var idx = parseInt(el.getAttribute('data-trending-tab'), 10);
        switchTab(idx);
      });
    });

    // Cache the initial tab content
    cache[active] = grid.innerHTML;
  }

  function boot() {
    document.querySelectorAll('[data-trending-collection]').forEach(initTrending);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var roots = e.target.querySelectorAll('[data-trending-collection]');
    roots.forEach(initTrending);
  });
})();
